import { jsx as _jsx } from "react/jsx-runtime";
import { SafeInnerHtmlSetter } from 'components/shared/util/SafeInnerHtmlSetter';
import styles from './index.module.scss';
/** Represents a component that is used to visualize a highlighted word. */
export const Highlight = ({ highlightedValue, }) => {
    return (_jsx(SafeInnerHtmlSetter, { element: "span", content: highlightedValue, profile: "highlight", className: styles.highlighter }));
};
